/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Commandautomatep22Inputs */



/**
* | output |
* | --- |
* | "Right/bottom pump controller command" |
*
* @param {Ahu_History_Key_Commandautomatep22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_commandautomatep22 = /** @type {((inputs?: Ahu_History_Key_Commandautomatep22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Commandautomatep22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/bottom pump controller command")
	return /** @type {LocalizedString} */ ("Commande automate pompe droite/basse")
});
export { ahu_history_key_commandautomatep22 as "ahu_history_key_commandAutomateP2" }